<template>
  <div class="row contractedJourneysTable">
    <div class="col-12">
      <b-table :items="items" :fields="fields" :hover="true" :sort-by.sync="sortByTable" :sort-desc.sync="sortOrder"
  :per-page="perPage" :current-page="1" label-sort-asc="" label-sort-desc="" label-sort-clear="" sort-icon-right
  show-empty :no-border-collapse="true" responsive="lg" thead-class="table-thead text-center bg-transparent "
  tbody-class="table-tbody text-center cursor-pointer" ref="selectableTable" info="true"
  no-sort-reset
  class="new-theme-custom-table" @row-clicked="(item) => $emit('row-clicked', item)" @sort-changed="handleSort"
  no-local-sorting>
        <template #empty> {{ $t("empty-row") }} </template>
         <template #cell(scheduledStartTime)="{ item }">
          <div v-if="item.scheduledStartDate" class="d-flex flex-column align-items-center">
            <span>{{ item.scheduledStartDate }}</span>
            <span class="text-muted">{{ item.scheduledStartTime }}</span>
          </div>
        </template>

        <!-- Merged End Date + End Time -->
        <template #cell(scheduledEndTime)="{ item }">
          <div v-if="item.scheduledEndDate" class="d-flex flex-column align-items-center">
            <span>{{ item.scheduledEndDate }}</span>
            <span class="text-muted">{{ item.scheduledEndTime }}</span>
          </div>
        </template>
        <template #cell(status)="{ item }">
          <div v-if="item.status" class="d-flex justify-content-center">
            <span :class="[
              'trip-status',
              {
                on_hold_status:
                  item.status === 'Booking-Pending',
              },
              {
                completed_status:
                  item.status === 'Booking-Confirmed' ||
                  item.status === 'Trip-Completed' ||
                  item.status === 'Trip-Completed-Note',
              },
              {
                canceled_status:
                  item.status === 'Booking-Cancelled' ||
                  item.status === 'Booking-Cancelled-Note',
              },
              {
                rescheduled_status:
                  item.status === 'Booking-Re-Assigned' ||
                  item.status === 'Trip-Arrived-At-Pickup-Location',
              },
              {
                started_status:
                  item.status === 'Trip-Started' ||
                  item.status === 'Trip-Passenger-Picked-Up',
              },
              {
                un_assigned_status:
                  item.status === 'Booking-Un-Assigned',
              },
              {
                arrived_to_dropped_off_status:
                  item.status === 'Trip-Arrived-To-Dropped-Off',
              },
              {
                dropped_off_status:
                  item.status === 'Trip-Passenger-Dropped-Off',
              },
            ]">
              {{ $t(item.status) }}
            </span>
          </div>
        </template>
        <template #cell(sub_status)="{ item }">
          <div v-if="item.sub_status" v-b-tooltip.hover.top="$t(item.sub_status?.toLowerCase())"
            class="d-flex justify-content-center">
            <div v-if="item.sub_status === 'Reviewed'" class="icon" style="background: var(--color-92)">
              <img :src="require(`@/assets/images/icons/arrow-refresh-icon.svg`)" alt="arrow-refresh-icon" />
            </div>
            <div v-else-if="item.sub_status === 'Approval-Needed'" class="icon" style="background: var(--color-125)">
              <img :src="require(`@/assets/images/icons/clock-1-icon.svg`)" alt="clock-icon" />
            </div>
            <div v-else-if="item.sub_status === 'Action-Required'" class="icon" style="background: var(--color-124)">
              <img :src="require(`@/assets/images/icons/alert-triangle-icon.svg`)" alt="alert-triangle-icon" />
            </div>
            <div v-else-if="item.sub_status === 'Archived'" class="icon" style="background: var(--color-131)">
              <img :src="require(`@/assets/images/icons/archive-icon.svg`)" alt="archived-icon" height="17" />
            </div>
          </div>
        </template>
      </b-table>
      <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" first-number last-number
        aria-controls="my-table" class="d-flex justify-content-end"></b-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: ["items", "total", "perPage", "page", "sortBy", "sortDesc"],
  emits: ["change-page", "row-clicked"],
  data() {
    return {
     currentPage: this.page,
    sortByTable: this.sortBy.replace("-", ""),
    sortOrder: this.sortDesc,
      fields: [
        {
          key: "blanketOrderId",
          label: this.$t("contract-code"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "beneficiaryNationalId",
          label: this.$t("beneficiary-national-id"),
          class: "align-middle",
          sortable: false,
        },
        // {
        //   key: "reference_number",
        //   label: this.$t("reference-number"),
        //   class: "align-middle",
        //   sortable: false,
        // },
        {
          key: "client",
          label: this.$t("client"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "service",
          label: this.$t("service"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "zone",
          label: this.$t("zone"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "garage",
          label: this.$t("garage"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "waterSource",
          label: this.$t("water-source"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "_id",
          label: this.$t("trip-id"),
          class: "align-middle",
          thStyle: {
            backgroundPosition: "right .1rem center !important",
            paddingRight: "15px !important",
          },
          sortable: true,
        },
        {
          key: "start",
          label: this.$t("pick-up-location"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "end",
          label: this.$t("drop-off-location"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "scheduledStartTime",
          label:  this.$t("start-date"),
          class: "align-middle",
          thStyle: {
            backgroundPosition: "right .1rem center !important",
            paddingRight: "15px !important",
            minWidth: "110px",
          },
          sortable: true,
        },
      
        {
          key: "scheduledEndTime",
          label: this.$t("end-date"),
          class: "align-middle",
          thStyle: {
            backgroundPosition: "right .1rem center !important",
            paddingRight: "15px !important",
            minWidth: "110px",
          },
          sortable: true,
        },
        {
          key: "driver",
          label: this.$t("iqama-number-entry-driver"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "driverMobileNumber",
          label: this.$t("mobile-number"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "vehicle",
          label: this.$t("plate-number"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "branch",
          label: this.$t("branch"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "status",
          label: this.$t("status"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "sub_status",
          label: this.$t("update"),
          class: "align-middle",
          sortable: false,
        },
      ],
    };
  },
  methods: {
     handleSort({ sortBy, sortDesc }) {
    if (!sortBy) {
      // Shouldn't happen once no-sort-reset is set, but guard just in case
      // by re-emitting the previous known state instead of doing nothing.
      this.$emit("sort-changed", { sortBy: this.sortByTable, sortDesc: this.sortOrder });
      return;
    }
    this.$emit("sort-changed", { sortBy, sortDesc });
  },
  },
 watch: {
  currentPage(val) {
    this.$emit("change-page", val);
  },
  sortBy(newVal) {
    this.sortByTable = newVal ? newVal.replace("-", "") : newVal;
  },
  sortDesc(newVal) {
    this.sortOrder = newVal;
  },
},
  i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/manageTrips.json"),
      ar: require("@/services/i18n/locales/ar/manageTrips.json"),
    },
  },
};
</script>

<style lang="scss">
.contractedJourneysTable {
  .table.b-table {
    thead {
      tr {
        [aria-sort] {
          background-size: 13px !important;
        }

        th {
          font-size: 10px !important;
          padding-inline: 2px;
        }
      }
    }

    tbody {
      tr {
        td {
          font-size: 10px !important;
          padding: 2px;
        }
      }

      .trip-status {
        border-radius: 8px;
        font-size: 10px;
        font-weight: 700;
        padding: 5px;
      }

      .on_hold_status {
        background: var(--color-48);
        border: 1px solid var(--color-40);
        color: var(--color-29);
      }

      .completed_status {
        background: var(--color-19);
        border: 1px solid var(--color-16);
        color: var(--color-12);
      }

      .canceled_status {
        background: var(--color-20);
        border: 1px solid var(--color-39);
        color: var(--color-27);
      }

      .rescheduled_status {
        background: var(--color-18);
        border: 1px solid var(--color-41);
        color: var(--color-30);
      }

      .started_status {
        background: var(--color-52);
        border: 1px solid var(--color-41);
        color: var(--color-01);
      }

      .un_assigned_status {
        background: var(--color-47);
        border: 1px solid var(--color-39);
        color: var(--color-01);
      }

      .arrived_to_dropped_off_status {
        background: var(--color-130);
        border: 1px solid var(--color-41);
        color: var(--color-01);
      }

      .dropped_off_status {
        background: var(--color-05);
        border: 1px solid var(--color-41);
        color: var(--color-01);
      }

      .icon {
        height: 24px;
        width: 24px;
        padding: 0.4375rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
      }
    }
  }
}
</style>